import { Typography } from "@maxhub/max-ui"

export const TypographyHeadlineExample = {
    title: 'Typography.Headline',
    defaultPlatform: 'ios',
    defaultZoom: 100,

    controls: [
        {
            name: 'children',
            label: 'children',
            type: 'text',
            tsType: 'string',
            default: 'Hello world',
        },
        {
            name: 'asChild',
            label: 'asChild',
            type: 'static',
            tsType: 'boolean',
            value: '-',
        },
        {
            name: 'variant',
            label: 'variant',
            type: 'enum',
            tsType: ['"small"', '"medium"', '"custom"', '"large-strong"'],
            default: 'large-strong',
            options: ['small', 'medium', 'custom', 'large-strong'],
        },
    ],

    Preview({ props }){
        const headlineProps = {
            ...(props.variant ? { variant: props.variant } : {}),
        }

        return (
            <Typography.Headline {...headlineProps}>
                {props.children}
            </Typography.Headline>
        )
    },

    getCode(props){
        return `<Typography.Headline${props.variant !== 'large-strong' ? `\n  variant="${props.variant}"` : ''}>
  ${props.children}
</Typography.Headline>`
    }

}